import { BodyCopy } from '@xing-com/typography';

import { CompanyLink } from './company-link';

type Props = {
  link?: string;
  trackingParams?: string;
  name?: string;
};

export const CompanyName: React.FC<Props> = ({
  link,
  trackingParams,
  name,
}) => {
  return (
    <CompanyLink link={link} trackingParams={trackingParams}>
      <BodyCopy
        noMargin
        size="medium"
        sizeConfined="xlarge"
        data-testid="job-details-company-info-name"
      >
        {name}
      </BodyCopy>
    </CompanyLink>
  );
};
